import { render, staticRenderFns } from "./Surveillance.vue?vue&type=template&id=32a35afa&scoped=true&"
import script from "./Surveillance.vue?vue&type=script&lang=js&"
export * from "./Surveillance.vue?vue&type=script&lang=js&"
import style0 from "./Surveillance.vue?vue&type=style&index=0&id=32a35afa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a35afa",
  null
  
)

export default component.exports